export default {
    BANKLOAN: "bankloan",
    RIC: "ric",
    RISA: "risa",
    FINWISE: "fixed_installment_loan",
    CREDIT: "credit",
    LOAN: "loan"
}
